module.exports = __webpack_public_path__ + "img/i_main_s_my_internet.cdc0a9aa.svg";